const normalizeUrl = (raw) => {
    if (!raw) return null;
    try {
        const withScheme = /^[a-zA-Z][a-zA-Z0-9+\-.]*:/.test(raw) ? raw : `https://${raw}`;
        const u = new URL(withScheme);
        return ['http:', 'https:'].includes(u.protocol) ? u.toString() : null;
    } catch {
        return null;
    }
};

export default normalizeUrl;
